/** Existing bundle images may use document-relative URLs. The edit API uses
 * root-relative URLs so the same image survives a save from any page. */
export function imageEditSource(src: string, page = "index.html"): string {
  if (!src || /^(?:[a-z][a-z0-9+.-]*:|\/|#)/i.test(src)) return src;
  const file = page.endsWith(".html") ? page : `${page.replace(/\/$/, "")}/index.html`;
  try {
    const url = new URL(src, `https://site.invalid/${file.replace(/^\//, "")}`);
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return src; }
}
